export const SPA_CART_EXPIRATION_MS = 19.5 * 60 * 1000 // 19.5 minutes until the cart is reset
export const SPA_CART_EXPIRATION_WARNING_MS = 3 * 60 * 1000 // Show warning when 3 minutes are left
export const SPA_ALLOWED_ADULTS = 14 // Maximum allowed number of Adults for a spa booking
